import { render } from "./SuccessModel2.vue?vue&type=template&id=ce533d50&scoped=true"
import script from "./SuccessModel2.vue?vue&type=script&lang=js"
export * from "./SuccessModel2.vue?vue&type=script&lang=js"

import "./SuccessModel2.vue?vue&type=style&index=0&id=ce533d50&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce533d50"]])

export default __exports__